import dataFilter from '@/filters/dataFilter'
import displayFilter from '@/filters/displayFilter'

export default Object.assign({}, 
    dataFilter,
    displayFilter
)



// WEBPACK FOOTER //
// ./src/filters/index.js